module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('v-parallax', {
    attrs: {
      "height": _vm.windowHeight,
      "dark": "",
      "src": require('../assets/HajimeToolsHome.jpg')
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "column": "",
      "justify-center": ""
    }
  }, [_c('h1', {
    staticClass: "hometitle"
  }, [_vm._v("Hajime-Tools")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08860f28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 478
// module chunks = 1